import { Alert, Text } from "@seneca/senekit";

import { ErrorMessage as ErrorMessageType } from "services/firebase/auth/errorTranslator";

export default function ErrorMessage({
  errorMessage
}: {
  errorMessage: ErrorMessageType;
}) {
  const { message, link, linkText } = errorMessage;

  const buttonProps =
    link && linkText ? { to: link, text: linkText } : undefined;

  return (
    <Alert iconName="exclamationCircle" tone="error" buttonProps={buttonProps}>
      <Text tone="error">{message}</Text>
    </Alert>
  );
}
